
import {dataService} from "../App";
import { FORM_URL_ENCODED_HEADERS_CONF } from 'utils/requestHelpers';
import history from '../history';
import store from '../store/index';
import { logout } from 'actions/auth.action.js';
/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */

export const checkLoginWhitelist = (msisdn) => {
  return dataService.get(`/users/${msisdn}/checkLoginWhitelist`);
}

export const login =  (data)=> {
  var postData = 'password=' + data.password;
  return dataService.post(
    `/users/${data.msisdn}/login`, postData , FORM_URL_ENCODED_HEADERS_CONF
  );
}

export const  sendOtp  = (data)=>  {
  return dataService.post(
    `/users/${data.msisdn}/otp/loginSend/${data.otpMsisdn}`, {} ,
    {headers: { preToken: data.preToken }}
  );

  // return request(`/users/${data.msisdn}/otp/loginSend/${data.otpMsisdn}`, {
  //   method: 'post',
  //   data: postData,
  //   headers: { preToken: data.preToken },
  // });
}

export const getOtpMsisdns=(token)=> {
  return dataService.get(`/users/userMsisdnList`, {
    headers: { preToken: token },
  });
}

export const validateLoginOtp = (data)=> {
  var postData = 'otp=' + data.otp;
  
  return dataService.post(
    `/users/${data.msisdn}/otp/loginCheck`, postData ,
    {
      headers: { preToken: data.preToken }
    }
  );
  // return request(`/users/${data.msisdn}/otp/loginCheck`, {
  //   method: 'post',
  //   data: postData,
  //   headers: { preToken: data.preToken },
  // });
}

export const sendRegisterOtp = (data) =>{
  return dataService.post(`/users/${data.msisdn}/register/otp`);
}

export const sendForgetOtp = (data) =>{
  return dataService.post(`/users/${data.msisdn}/forget/otp`);
}

export const validateOtp=(data) => {
  var postData = 'otp=' + data.otp;
  return dataService.post(`/users/${data.msisdn}/otp/check`,  postData,
   { headers: { preToken: data.preToken },
  });
}

export const logoutUser =(data) => {
  return dataService.post(`/users/${data.msisdn}/logout`,null,{});
}

export const passwordChange=(data) => {
  var postData =
    'newPassword=' + data.newPassword;
  return dataService.put(`/users/${data.msisdn}/password`, postData, FORM_URL_ENCODED_HEADERS_CONF);
}


export const logoutPure =() => {
  dataService.post(`/users/logout`).then((result) => {
    
  }).catch((err) => {
    
  }).finally(()=> {
    store.dispatch(logout());
    history.push("/Login");
  });
}

export const logoutUnAuth =() => dispatch =>  {
  logoutPure();
  
}
